import { Message, Sender } from 'services/conversations/types';

export const checkProspectHasMessaged = (messages: Message[]) => {
  // Filter the messages sent by PROSPECT
  const prospectMessages = messages.filter(
    (message) => message.sender === Sender.PROSPECT
  );

  if (!prospectMessages.length) return false;

  return true;
};
